/*
 Holds the period payouts as defined by the customer
*/
export const payoutPeriods = {
    spring: {
        payoutMonth: 6, // The month the payout takes place and the employee must still be valid / part of the company
        deletionDeadlineMonth: 4, // April
        deletionDeadlineDay: 30, // 30 April
        travelEndDate: {
            // The releavant application which will be handled in the payout
            start: {
                month: 10 // Previous FY - October
            },
            end: {
                month: 3 // March
            }
        }
    },
    winter: {
        payoutMonth: 12, // December
        deletionDeadlineMonth: 10, // October
        deletionDeadlineDay: 30, // 30 October
        travelEndDate: {
            start: {
                month: 4 // April
            },
            end: {
                month: 9 // September
            }
        }
    }
};

// Externals and Working Students are not allowed to submit applications
export const ineligibleEmployeeGroups = ['5', '6'];
export const minimumTravelDurationDays = 7;
